<template>
  <div>
      <!-- :style="
        this.scrollPosition == true
          ? 'box-shadow: 0 6px 6px #000000; height: 64px;'
          : ''
      " -->
    <nav
      class="navbar navbar-expand-xl navbar-expand-lg fixed-top navbar-light bg-faded avnav"
      :style="{ 'height': this.scrollPosition === 0 ? '78px' : '64px', 'transition': 'height 0.5s' }"
    >
      <div class="container">
        <!-- style="transition: height 0.5s;" -->
        <button
          class="toggle navbar-toggler navbar-toggler-left p-0"
          @click="toogle"
          type="button"
          style="border: none"
        >
          <span
            ><i class="fa fa-bars" style="color: #606060" aria-hidden="true"></i
          ></span>
        </button>
        <div
          class="overlay-nav"
          v-bind:class="{ bodyOverlay: mobileNavBar }"
          @click="toogleClose"
        ></div>
        <a :href="get_home_path" class="mr-auto">
          <img
            style=""
            class="logo"
            :src="get_img_path + '/workflow/hp_v1/Avishkaar_Logo.png'"
            alt="avishkaar logo"
          />
        </a>
              <a
            :href="get_web_path + '/search'"
            class="my-auto mr-2 d-lg-none"
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 18 18"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <path
                  d="M12.5,11 L11.71,11 L11.43,10.73 C12.41,9.59 13,8.11 13,6.5 C13,2.91 10.09,0 6.5,0 C2.91,0 0,2.91 0,6.5 C0,10.09 2.91,13 6.5,13 C8.11,13 9.59,12.41 10.73,11.43 L11,11.71 L11,12.5 L16,17.49 L17.49,16 L12.5,11 Z M6.5,11 C4.01,11 2,8.99 2,6.5 C2,4.01 4.01,2 6.5,2 C8.99,2 11,4.01 11,6.5 C11,8.99 8.99,11 6.5,11 Z"
                  id="path-1"
                ></path>
              </defs>
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g id="Header" transform="translate(-1056.000000, -57.000000)">
                  <g id="Group" transform="translate(128.000000, 48.000000)">
                    <g id="Group-9" transform="translate(928.000000, 0.000000)">
                      <g
                        id="icon/action/search_24px"
                        transform="translate(0.000000, 9.000000)"
                      >
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use
                          id="-↳Color"
                          fill="#505050"
                          xlink:href="#path-1"
                        ></use>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
        <div class="tooltip-container d-block d-lg-none" id="mobile-header-cart">
          <div class="shop-cart">
            <span
              class="current_count_value"
              v-if="cartQty"
              id="current_current_value"
              style="background: #f36f2e"
              >{{ cartQty }}</span
            >
            <div
              @click="sideCartViewOpenMobile"
              class="ml-2 blank_cart_icon"
              id="blank_cart_icon"
            >
              <svg
                width="20px"
                height="20px"
                viewBox="0 0 20 20"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g id="Header" transform="translate(-1094.000000, -56.000000)">
                    <g id="Group" transform="translate(128.000000, 48.000000)">
                      <g id="Group-9" transform="translate(928.000000, 0.000000)">
                        <g
                          id="shopping_cart-24px-(1)"
                          transform="translate(37.000000, 6.000000)"
                        >
                          <polygon
                            id="Path"
                            points="0 0 24 0 24 24 0 24"
                          ></polygon>
                          <path
                            d="M15.55,13 C16.3,13 16.96,12.59 17.3,11.97 L20.88,5.48 C21.25,4.82 20.77,4 20.01,4 L5.21,4 L4.27,2 L1,2 L1,4 L3,4 L6.6,11.59 L5.25,14.03 C4.52,15.37 5.48,17 7,17 L19,17 L19,15 L7,15 L8.1,13 L15.55,13 Z M6.16,6 L18.31,6 L15.55,11 L8.53,11 L6.16,6 Z M7,18 C5.9,18 5.01,18.9 5.01,20 C5.01,21.1 5.9,22 7,22 C8.1,22 9,21.1 9,20 C9,18.9 8.1,18 7,18 Z M17,18 C15.9,18 15.01,18.9 15.01,20 C15.01,21.1 15.9,22 17,22 C18.1,22 19,21.1 19,20 C19,18.9 18.1,18 17,18 Z"
                            id="Shape"
                            fill="#505050"
                            fill-rule="nonzero"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div
            class="tooltip-content-cart d-flex"
            v-bind:class="{ sideCartView: sideCartViewMobile }"
          >
            <div
              class="back_drop h-100 col-md-8 col-1 px-0"
              @click="sideBarCartCloseMobile"
            ></div>
            <div class="inner-shop col-md-4 col-11">
              <div
                class="d-flex w-100 p-4"
                style="border-bottom: 0.5px solid #e0e0e0"
              >
                <h5 class="pr-2">Shopping Cart</h5>
                <span style="color: #909090">({{ cartQty }} item)</span>
                <div
                  style="position: absolute; right: 15px; z-index: 1"
                  @click="sideBarCartCloseMobile"
                >
                  <svg
                    style="cursor: pointer"
                    class="ml-auto shopping-cart-close1"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.4751 1.785L13.0651 0.375L7.4751 5.965L1.8851 0.375L0.475098 1.785L6.0651 7.375L0.475098 12.965L1.8851 14.375L7.4751 8.785L13.0651 14.375L14.4751 12.965L8.8851 7.375L14.4751 1.785Z"
                      fill="black"
                    ></path>
                  </svg>
                </div>
              </div>
              <div class="d-flex flex-wrap" style="height: 90%">
                <div class="w-100 pt-2 mt-2 text-center">
                  <div v-if="cartEmpty">
                    <p>Your Avishkaar Cart is empty.</p>
                    <a
                      :href="get_web_path + '/products'"
                      class="btn header-check-but btn-primary py-2"
                      >See Avishkaar Products</a
                    >
                  </div>
                  <div style="height: 88%" v-else>
                    <div
                      class="w-100 px-4 pt-4 mt-2 cart_scroll text-center"
                      style="overflow: scroll"
                    >
                      <div class="tooltip-items-cart">
                        <img
                          src="https://images.avishkaar.cc/workflow/shop/close_icon.png"
                          alt="cart"
                          class="float-right image-cart-close d-none"
                        />
                        <div
                          class="row py-2 mb-3 inner-shop-count-card"
                          :key="userCartKey"
                          v-for="(userCart, userCartKey) in userCart.itemDetails"
                        >
                          <div
                            class="col-4 header-img-height cart_product_FGMI-HD-0001"
                          >
                            <img
                              style="
                                opacity: 1 !important;
                                transform: scale(1);
                                max-width: 100%;
                              "
                              :src="userCart.image"
                              :alt="userCart.product_name"
                              class="image-fade"
                            />
                          </div>
                          <div class="col-8 py-2 text-left">
                            <p class="m-0">{{ userCart.product_name }}</p>
                            <div
                              class="shop_inc_dec_container1 shop_quantity_check pt-2 pb-5"
                            >
                              <div
                                class="button-container1 d-flex align-items-center"
                              >
                                <button
                                  v-show="userCart.quantity > 1"
                                  class="inc_dec_btn cart-qty-minus"
                                  type="button"
                                  @click="updateQuantity(userCart, false)"
                                >
                                  <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="8.65869"
                                      cy="8.45312"
                                      r="7.5"
                                      stroke="#606060"
                                    ></circle>
                                    <path
                                      d="M10.6587 9.45312H6.65869V7.45312H10.6587V9.45312Z"
                                      fill="#606060"
                                    ></path>
                                  </svg>
                                </button>
                                <input
                                  type="text"
                                  disabled=""
                                  name="qty"
                                  style="background: white"
                                  class="qty_FGMI-HD-0001 quantity text-center"
                                  maxlength="12"
                                  :value="userCart.quantity"
                                />
                                <button
                                  v-show="
                                    userCart.quantity <
                                    userCart.online_max_quantity
                                  "
                                  class="inc_dec_btn cart-qty-plus"
                                  type="button"
                                  @click="updateQuantity(userCart, true)"
                                >
                                  <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <circle
                                      cx="8.65869"
                                      cy="8.45312"
                                      r="7.5"
                                      stroke="#606060"
                                    ></circle>
                                    <path
                                      d="M9.48835 7.66633H11.6587V9.14369H9.48835V11.4531H7.83504V9.14369H5.65869V7.66633H7.83504V5.45312H9.48835V7.66633Z"
                                      fill="#606060"
                                    ></path>
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <button
                              @click="deleteProduct(userCart.product_code)"
                              style="
                                position: absolute;
                                cursor: pointer;
                                color: #e63638;
                                background: transparent;
                                border: none;
                                bottom: 0;
                                left: 10px;
                              "
                              class="mb-0 mt-2"
                            >
                              Remove
                            </button>
                            <div class="mt-auto">
                              <h6
                                style="position: absolute; right: 0; bottom: 0"
                                class="mb-0"
                              >
                                ₹ {{ userCart.total_amount.toLocaleString() }}/-
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="mt-auto py-4 px-2"
                      style="
                        border-top: 0.5px solid #e0e0e0;
                        background: white;
                        width: 94% !important;
                        z-index: 1;
                      "
                    >
                      <div class="d-flex flex-wrap">
                        <div class="col-6 text-left">
                          <span style="color: #909090; font-size: 14px"
                            >Subtotal</span
                          >
                          <h5 class="my-1 subtotal" id="subtotal">
                            ₹ {{ subtotal.toLocaleString() }}/-
                          </h5>
                          <p
                            class="m-0"
                            style="
                              font-size: 12px;
                              color: #909090;
                              line-height: 12px;
                            "
                          >
                            Inclusive of all taxes and shipping across India
                          </p>
                        </div>
                        <div class="col-6 my-auto">
                          <router-link
                            to="/buy"
                            class="btn py-3 col-12 login_next_btn"
                            style="font-weight: bold; border: none; color: white"
                            >Checkout</router-link
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="navbar-collapse navbar-custom">
          <ul
            class="navbar-nav mr-auto navigation-list p-0"
            v-bind:class="{ navCollsaped: mobileNavBar }"
                  style="width: 70% !important;"
          >
            <a :href="get_home_path" class="d-block d-lg-none text-left">
              <img
                class="logo mt-3 mb-3 ml-3"
                :src="get_img_path + '/misc/profile/images/avishkaar-logo.png'"
                alt="avishkaar logo"
                loading="lazy"
                style="left:0"
              />
            </a>
            <div class="d-flex" v-if="loggedIn">
                    <!-- <img
                  class="logo my-3 d-block d-lg-none"
                  :src="get_img_path + '/brand/avishkaar_logo.png'"
                  alt="avishkaar logo"
                /> -->
              <!-- <div class="p-4 login-inner d-block d-lg-none mb-4 text-left w-100">
                <img
                  class="logo"
                  :src="get_img_path + '/brand/logo-white.png'"
                  alt="avishkaar logo"
                />
                <div class="d-flex py-4">
                  <div class="header-user-logo-mobile">
                    <img
                      :src="get_img_path + '/workflow/user/profile.png'"
                      alt="avishkaar logo"
                      height="100%"
                      class="image-fade"
                    />
                  </div>
                  <p class="m-0 mx-3 text-white my-auto">
                    Hi,
                    <a
                      class="text-white"
                      :href="get_web_path + '/users/' + userUri"
                      style="font-weight: 400; color: white !important"
                      >{{ userName }}</a
                    >
                  </p>
                </div>
                <div class="col-12 row px-0 login-button">
                  <div class="col-6 px-1">
                    <a
                      class="btn px-2 py-1"
                      :href="get_web_path + '/users/' + userUri"
                      >My Profile
                    </a>
                  </div>
                  <div class="col-6 px-1">
                    <a class="btn px-2 py-1" :href="get_web_path + '/myorders'">
                      My Order
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
            <div v-else>
              <div class="login-inner nav-left-logo-box d-block d-lg-none">
                <!-- <img
                  class="logo my-3"
                  :src="get_img_path + '/brand/avishkaar_logo.png'"
                  alt="avishkaar logo"
                /> -->
                <!-- <div class="d-flex py-4">
                  <div class="header-user-logo-mobile">
                    <img
                      :src="get_img_path + '/workflow/user/profile.png'"
                      alt="avishkaar logo"
                      height="100%"
                    />
                  </div>
                  <a :href="get_web_path + '/login'"
                    ><p
                      class="m-0 mx-3 text-white my-auto"
                      data-toggle="modal"
                      data-target="#loginmodal"
                      style="font-weight: 600; cursor: pointer"
                    >
                      Sign In / Register
                    </p></a
                  >
                </div> -->
              </div>
            </div>
            <b-navbar-nav class="text-left h-100 d-none d-lg-flex">
              <!-- <b-nav-item :class="[currentPage === '/' ? 'nav-element-active' : '' ,'my-left-nav-item d-none d-lg-flex']" :href="get_web_path"
                ><div class="my-left-nav-item-text" :style="{ 'color': currentPage === '/' ? '#26221f' : '' }">Home</div>
              </b-nav-item> -->
              <b-nav-item
                :class="[currentPage.startsWith('/shop') || currentPage.startsWith('/products') || currentPage.startsWith('/courses')  ? 'nav-element-active' : '' , 'my-left-nav-item']"
                :href="'https://shop.avishkaar.cc/'"
              >
                  <div class="my-left-nav-item-text" :style="{ 'color': currentPage.startsWith('/shop') ? '#26221f' : 'rgba(0, 0, 0, 0.5)' }">
                    Shop
                  </div>
              </b-nav-item>
              <!-- <b-nav-item
                class="my-left-nav-item"
                :href="get_web_path + '/courses'"
                ><div class="my-left-nav-item-text">COURSES</div></b-nav-item
              > -->
              <b-nav-item
                class="my-left-nav-item"
                href="https://community.avishkaar.cc"
              >
                <div class="my-left-nav-item-text">Competitions</div>
              </b-nav-item>
              <b-nav-item
                class="my-left-nav-item"
                href="https://community.avishkaar.cc/projects"
              >
                <div class="my-left-nav-item-text">Projects</div>
              </b-nav-item>
              <b-nav-item
                class="my-left-nav-item"
                v-if="admin == 'admin'"
                :href="get_web_path + '/admin'"
              >
                <div class="my-left-nav-item-text">Admin</div>
              </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="text-left d-lg-none d-block pb-3">
              <b-nav-item class="p-0" href="https://shop.avishkaar.cc/">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/shop-icon.png" alt="Shop" /></div>
                  <div class="mobile-nav-text">Shop</div>
                </div>
              </b-nav-item>
              <b-nav-item class="p-0" href="https://community.avishkaar.cc">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/competitions-icon.png" alt="Competitions" /></div>
                  <div class="mobile-nav-text">Competitions</div>
                </div>
              </b-nav-item>
              <b-nav-item class="p-0">
                <a class="mobile-nav-item" href="https://community.avishkaar.cc/projects">
                  <div class="mobile-nav-img"><img :src="'https://images.avishkaar.cc/misc/profile/side-nav/projects-icon.png'" alt="Projects" /></div>
                  <div class="mobile-nav-text">Projects</div>
                </a>
              </b-nav-item>
              <b-nav-item class="p-0" :href="get_web_path + '/admin'" v-if="admin == 'admin'">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/my-profile-icon.png" alt="Admin" /></div>
                  <div class="mobile-nav-text">Admin</div>
                </div>
              </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav
              v-if="loggedIn"
              class="text-left d-lg-none d-block py-3"
              style="border-top: 1px solid #ebebeb"
            >
              <!-- <b-nav-item class="pt-2">
                    <div class="d-flex justify-content-between mobile-profile-option">
                      <router-link :to="'/profile/'" class="navbar-light navbar-nav nav-link">Welcome, {{ userName }}!</router-link>
                    </div>
                    </b-nav-item
              >
              <b-nav-item class="mobile-nav-footer-options">
                     <router-link :to="'/profile/'" class="navbar-light navbar-nav nav-link" v-if="userDetails.username != null"> My Profile</router-link>
                    </b-nav-item>
              <b-nav-item :href="get_web_path + '/my-courses'" class="mobile-nav-footer-options">
                      My Courses
                    </b-nav-item>
              <b-nav-item :href="get_web_path + '/myorders'" class="mobile-nav-footer-options">
                      My Orders
                    </b-nav-item>
              <b-nav-item :href="get_web_path + '/logout'" class="mobile-nav-footer-options">
                      Logout
                    </b-nav-item> -->
              <b-nav-item class="p-0" v-if="userDetails.username != null">
                <a class="mobile-nav-item" :href="get_home_path + '/profile'">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/my-profile-icon.png" alt="My Profile" /></div>
                  <div class="mobile-nav-text">My Profile</div>
                </a>
              </b-nav-item>
              <b-nav-item class="p-0" :href="get_web_path + '/myorders'">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/my-orders-icon.png" alt="My Orders" /></div>
                  <div class="mobile-nav-text">My Orders</div>
                </div>
              </b-nav-item>
              <b-nav-item class="p-0" :href="get_web_path + '/my-courses'">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/my-courses-icon.png" alt="My Courses" /></div>
                  <div class="mobile-nav-text">My Courses</div>
                </div>
              </b-nav-item>
              <b-nav-item class="p-0" href="https://community.avishkaar.cc/profile/competitions">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/my-competitions-icon.png" alt="My Competitions" /></div>
                  <div class="mobile-nav-text">My Competitions</div>
                </div>
              </b-nav-item>
              <b-nav-item class="p-0" href="https://community.avishkaar.cc">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/community-icon.png" alt="Community" /></div>
                  <div class="mobile-nav-text">Community</div>
                </div>
              </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav v-if="loggedIn" class="text-left d-lg-none d-block py-4 mt-auto" style="border-top: 1px solid #ebebeb">
              <b-nav-item class="p-0">
                <a class="mobile-nav-item" :href="get_home_path + '/profile/settings'">
                  <div class="mobile-nav-img"><img :src="'https://images.avishkaar.cc/misc/profile/side-nav/settings-icon.png'" alt="My Settings" /></div>
                  <div class="mobile-nav-text">Settings</div>
                </a>
              </b-nav-item>
              <b-nav-item class="p-0" :href="get_web_path + '/logout'">
                <div class="mobile-nav-item">
                  <div class="mobile-nav-img"><img src="https://images.avishkaar.cc/misc/profile/side-nav/logout-icon.png" alt="Logout" /></div>
                  <div class="mobile-nav-text">Logout</div>
                </div>
              </b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="d-lg-none nav-left-signin" v-else>
              <b-nav-item :href="get_web_path+'/login'" class="nav-left-signin-item">Sign In</b-nav-item>
            </b-navbar-nav>
          </ul>
          <div class="d-flex" v-if="loggedIn">
            <div class="my-auto">
              <div class="d-flex">
                <div class="tooltip-container mr-4">
                  <div class="d-none d-lg-block">
                    <p
                      class="mt-3 d-none d-lg-flex user-name w-100"
                      style="cursor: pointer; flex-wrap: nowrap !important;"
                    >
                      <!-- <strong>Welcome {{ userName }}<a
                          :href="get_web_path + '/users/' + userUri"
                          style="font-weight: bold; color: #606060"
                        ></a
                        >!</strong
                      > -->
                      <strong style="min-width: 200px;">Welcome {{ userName }}!</strong>
                      <i class="fas fa-caret-down ml-1"></i>
                    </p>
                  </div>
                  <span class="tooltip-content px-3 pt-2 pb-1 d-none d-lg-block">
                    <a :href="get_home_path + '/profile'">
                      <p class="tooltip-content-p mb-1" v-if="userDetails.username != null">My Profile</p>
                    </a>
                    <a :href="get_web_path + '/my-courses'">
                      <p class="tooltip-content-p mb-1">My Courses</p>
                    </a>
                    <a :href="get_web_path + '/myorders'">
                      <p class="tooltip-content-p mb-1">My Order</p>
                    </a>
                    <a :href="get_web_path + '/logout'">
                      <p
                        class="m-0 logout-tooltip tooltip-content-p"
                        onclick="document.querySelector('form').submit();"
                      >
                        Logout
                      </p>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <a
            :href="get_web_path + '/search'"
            class="my-auto d-lg-block d-none mr-2"
          >
            <svg
              width="18px"
              height="18px"
              viewBox="0 0 18 18"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <path
                  d="M12.5,11 L11.71,11 L11.43,10.73 C12.41,9.59 13,8.11 13,6.5 C13,2.91 10.09,0 6.5,0 C2.91,0 0,2.91 0,6.5 C0,10.09 2.91,13 6.5,13 C8.11,13 9.59,12.41 10.73,11.43 L11,11.71 L11,12.5 L16,17.49 L17.49,16 L12.5,11 Z M6.5,11 C4.01,11 2,8.99 2,6.5 C2,4.01 4.01,2 6.5,2 C8.99,2 11,4.01 11,6.5 C11,8.99 8.99,11 6.5,11 Z"
                  id="path-1"
                ></path>
              </defs>
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g id="Header" transform="translate(-1056.000000, -57.000000)">
                  <g id="Group" transform="translate(128.000000, 48.000000)">
                    <g id="Group-9" transform="translate(928.000000, 0.000000)">
                      <g
                        id="icon/action/search_24px"
                        transform="translate(0.000000, 9.000000)"
                      >
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1"></use>
                        </mask>
                        <use
                          id="-↳Color"
                          fill="#505050"
                          xlink:href="#path-1"
                        ></use>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </a>
          <span class="ml-2 my-auto">
            <div
              class="tooltip-container mr-2 d-lg-block d-none"
              style="cursor: pointer"
              id="header-cart"
            >
              <div class="shop-cart">
                <span
                  class="current_count_value"
                  v-if="cartQty"
                  id="current_current_value"
                  style="background: #f36f2e"
                  >{{ cartQty }}</span
                >
                <div
                  @click="sideCartViewOpen"
                  class="ml-2 blank_cart_icon"
                  id="blank_cart_icon"
                >
                  <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                      id="Page-1"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="Header"
                        transform="translate(-1094.000000, -56.000000)"
                      >
                        <g
                          id="Group"
                          transform="translate(128.000000, 48.000000)"
                        >
                          <g
                            id="Group-9"
                            transform="translate(928.000000, 0.000000)"
                          >
                            <g
                              id="shopping_cart-24px-(1)"
                              transform="translate(37.000000, 6.000000)"
                            >
                              <polygon
                                id="Path"
                                points="0 0 24 0 24 24 0 24"
                              ></polygon>
                              <path
                                d="M15.55,13 C16.3,13 16.96,12.59 17.3,11.97 L20.88,5.48 C21.25,4.82 20.77,4 20.01,4 L5.21,4 L4.27,2 L1,2 L1,4 L3,4 L6.6,11.59 L5.25,14.03 C4.52,15.37 5.48,17 7,17 L19,17 L19,15 L7,15 L8.1,13 L15.55,13 Z M6.16,6 L18.31,6 L15.55,11 L8.53,11 L6.16,6 Z M7,18 C5.9,18 5.01,18.9 5.01,20 C5.01,21.1 5.9,22 7,22 C8.1,22 9,21.1 9,20 C9,18.9 8.1,18 7,18 Z M17,18 C15.9,18 15.01,18.9 15.01,20 C15.01,21.1 15.9,22 17,22 C18.1,22 19,21.1 19,20 C19,18.9 18.1,18 17,18 Z"
                                id="Shape"
                                fill="#505050"
                                fill-rule="nonzero"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <div
                class="tooltip-content-cart d-flex"
                v-bind:class="{ sideCartView: sideCartView }"
              >
                <div
                  class="back_drop h-100 col-md-8 col-1 px-0"
                  @click="sideBarCartClose"
                ></div>
                <div class="inner-shop col-md-4 col-11">
                  <div
                    class="d-flex w-100 p-4"
                    style="border-bottom: 0.5px solid #e0e0e0"
                  >
                    <h5 class="pr-2">Shopping Cart</h5>
                    <span style="color: #909090">({{ cartQty }} item)</span>
                    <svg
                      @click="sideBarCartClose"
                      style="cursor: pointer"
                      class="ml-auto shopping-cart-close1"
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.4751 1.785L13.0651 0.375L7.4751 5.965L1.8851 0.375L0.475098 1.785L6.0651 7.375L0.475098 12.965L1.8851 14.375L7.4751 8.785L13.0651 14.375L14.4751 12.965L8.8851 7.375L14.4751 1.785Z"
                        fill="black"
                      ></path>
                    </svg>
                  </div>
                  <div class="d-flex flex-wrap" style="height: 90%">
                    <div class="w-100 pt-2 mt-2 text-center">
                      <div v-if="cartEmpty">
                        <p>Your Avishkaar Cart is empty.</p>
                        <a
                          :href="get_web_path + '/products'"
                          class="btn header-check-but btn-primary py-2"
                          >See Avishkaar Products</a
                        >
                      </div>
                      <div class="h-100" v-else>
                        <div
                          class="w-100 px-4 pt-4 mt-2 cart_scroll text-center pb-0"
                          style="overflow: scroll"
                        >
                          <div class="tooltip-items-cart">
                            <img
                              src="https://images.avishkaar.cc/workflow/shop/close_icon.png"
                              alt="cart"
                              class="float-right image-cart-close d-none"
                            />
                            <div
                              class="row py-2 mb-3 inner-shop-count-card"
                              :key="userCartKey"
                              v-for="(
                                userCart, userCartKey
                              ) in userCart.itemDetails"
                            >
                              <div
                                class="col-4 header-img-height cart_product_FGMI-HD-0001"
                              >
                                <img
                                  style="
                                    opacity: 1 !important;
                                    transform: scale(1);
                                    max-width: 100%;
                                  "
                                  :src="userCart.image"
                                  :alt="userCart.product_name"
                                  class="image-fade"
                                />
                              </div>
                              <div class="col-8 py-2 text-left">
                                <p class="m-0">{{ userCart.product_name }}</p>
                                <div
                                  class="shop_inc_dec_container1 shop_quantity_check pt-2 pb-5"
                                >
                                  <div
                                    class="button-container1 d-flex align-items-center"
                                  >
                                    <button
                                      v-show="userCart.quantity > 1"
                                      class="inc_dec_btn cart-qty-minus"
                                      type="button"
                                      @click="updateQuantity(userCart, false)"
                                    >
                                      <svg
                                        width="17"
                                        height="17"
                                        viewBox="0 0 17 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle
                                          cx="8.65869"
                                          cy="8.45312"
                                          r="7.5"
                                          stroke="#606060"
                                        ></circle>
                                        <path
                                          d="M10.6587 9.45312H6.65869V7.45312H10.6587V9.45312Z"
                                          fill="#606060"
                                        ></path>
                                      </svg>
                                    </button>
                                    <input
                                      type="text"
                                      disabled=""
                                      name="qty"
                                      style="background: white"
                                      class="qty_FGMI-HD-0001 quantity text-center"
                                      maxlength="12"
                                      :value="userCart.quantity"
                                    />
                                    <button
                                      v-show="
                                        userCart.quantity <
                                        userCart.online_max_quantity
                                      "
                                      class="inc_dec_btn cart-qty-plus"
                                      type="button"
                                      @click="updateQuantity(userCart, true)"
                                    >
                                      <svg
                                        width="17"
                                        height="17"
                                        viewBox="0 0 17 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <circle
                                          cx="8.65869"
                                          cy="8.45312"
                                          r="7.5"
                                          stroke="#606060"
                                        ></circle>
                                        <path
                                          d="M9.48835 7.66633H11.6587V9.14369H9.48835V11.4531H7.83504V9.14369H5.65869V7.66633H7.83504V5.45312H9.48835V7.66633Z"
                                          fill="#606060"
                                        ></path>
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                                <button
                                  @click="deleteProduct(userCart.product_code)"
                                  style="
                                    position: absolute;
                                    cursor: pointer;
                                    color: #e63638;
                                    background: transparent;
                                    border: none;
                                    bottom: 0;
                                    left: 10px;
                                  "
                                  class="mb-0 mt-2"
                                >
                                  Remove
                                </button>
                                <div class="mt-auto">
                                  <h6
                                    style="
                                      position: absolute;
                                      right: 0;
                                      bottom: 0;
                                    "
                                    class="mb-0"
                                  >
                                    ₹
                                    {{ userCart.total_amount.toLocaleString() }}/-
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="mt-auto py-4 px-2"
                          style="
                            border-top: 0.5px solid #e0e0e0;
                            background: white;
                            width: 94% !important;
                            z-index: 1;
                          "
                        >
                          <div class="d-flex flex-wrap">
                            <div class="col-6 text-left">
                              <span style="color: #909090; font-size: 14px"
                                >Subtotal</span
                              >
                              <h5 class="my-1 subtotal" id="subtotal">
                                ₹ {{ subtotal.toLocaleString() }}/-
                              </h5>
                              <p
                                class="m-0"
                                style="
                                  font-size: 12px;
                                  color: #909090;
                                  line-height: 12px;
                                "
                              >
                                Inclusive of all taxes and shipping across India
                              </p>
                            </div>
                            <div class="col-6 my-auto">
                              <router-link
                                to="/buy"
                                class="btn py-3 col-12 login_next_btn"
                                style="
                                  font-weight: bold;
                                  border: none;
                                  color: white;
                                "
                                >Checkout</router-link
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>
          <div class="d-flex" v-if="loggedIn">
            <p
              class="text-white mt-3 d-lg-flex d-none mobile-navbar3 mx-3"
              style="font-weight: 400; cursor: pointer"
            >
              <a
                :href="get_web_path + '/ams'"
                style="color: #606060; font-weight: 900"
                class="px-2"
                >AMS</a
              >
            </p>
          </div>
          <div v-else>
            <a :href="get_web_path + '/login'"
              ><div class="d-flex mobile_cart_view">
                <p
                  class="mt-3 mobile-navbar3 mx-3 px-4 d-lg-flex d-none"
                  style="font-weight: 900; cursor: pointer"
                  data-toggle="modal"
                  data-target="#loginmodal"
                >
                  Sign In
                </p>
              </div></a
            >
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Header",
  props: ["sidebar"],
  data() {
    return {
      get_web_path: process.env.VUE_APP_SITE_URL,
      get_img_path: process.env.VUE_APP_IMAGE_URL,
      get_home_path: process.env.NODE_ENV === "production" ? "https://home.avishkaar.cc" : "http://localhost:1111",
      loggedIn: false,
      userName: "",
      admin: false,
      userUri: "",
      mobileNavBar: false,
      sideCartView: false,
      sideCartViewMobile: false,
      cartQty: 0,
      subtotal: 0,
      scrollPosition: false, // look for page scroll position for toggling navbar class,
			currentPage: "/",
    };
  },
  watch: {
    userCart: function (newVal) {
      if (newVal.itemDetails && newVal.itemDetails.length > 0) {
        this.cartQty = newVal.itemDetails.length;
        this.subtotal = newVal.amountDetails.totalAmount;
      }
    },
    userDetails: function (newVal) {
      if(newVal.phone_verified == 1 && (newVal.user_type == "student" && newVal.username == null) || (newVal.user_type == "undefined")){
        window.location = process.env.VUE_APP_SITE_URL+'/user/phone'
      }
      if (newVal.phone_verified == 1 || newVal.email_verified == 1) {
        this.loggedIn = true;
        this.userName = newVal.first_name;
        this.userUri = newVal.uri;
        this.admin = newVal.category;
      }

      // emit user type on login
      // if (this.$cookies.get("userAccess") !== null) this.$emit('user-type', this.userDetails.user_type);
      // else this.$emit('user-type', false);
    },
    sidebar: function (newval) {
      this.sideCartView = newval;
      this.sideCartViewMobile = newval;
    },
    cartEmpty: function (newVal) {
      if (newVal == true) this.cartQty = 0;
    },
  },
  computed: {
    ...mapGetters({ userCart: "getUserCart", userDetails: "getUserDetails" }),
    cartEmpty: {
      get: function () {
        return this.$store.getters.getCartEmpty;
      },
    },
  },
  methods: {
    ...mapActions([
      "fetchUserCart",
      "fetchLogoutItemDetails",
      "fetchUserDetails",
      "updateCartQuantity",
      "removeProduct",
    ]),
    toogle() {
      this.mobileNavBar = !this.mobileNavBar;
    },
    toogleClose() {
      this.mobileNavBar = !this.mobileNavBar;
    },
    sideCartViewOpen() {
      this.sideCartView = !this.sideCartView;
      // document.getElementById('productNav').classList.add("sticky");
    },
    sideBarCartClose() {
      this.sideCartView = !this.sideCartView;
      this.$parent.openSidebar();
      document.getElementById("productNav").classList.add("hideFilter");
    },
    sideCartViewOpenMobile() {
      this.sideCartViewMobile = !this.sideCartViewMobile;
    },
    sideBarCartCloseMobile() {
      this.sideCartViewMobile = !this.sideCartViewMobile;
      this.$parent.openSidebar();
      document.getElementById("productNav").classList.add("hideFilter");
    },
    deleteProduct(productCode) {
      if (this.$cookies.get("userAccess") !== null) {
        this.removeProduct({ productCode });
      } else {
        const userItem = JSON.parse(this.$cookies.get("userCart"));
        const itemIndex = userItem.findIndex(
          (item) => item.productCode == productCode
        );
        userItem.splice(itemIndex, 1);
        this.$cookies.set("userCart", JSON.stringify(userItem));
        this.fetchLogoutItemDetails();
      }
    },
    updateQuantity(userCart, status) {
      var quantity;
      if (status) quantity = userCart.quantity + 1;
      else quantity = userCart.quantity - 1;
      if (this.$cookies.get("userAccess") !== null) {
        const cartPayload = {
          cartId: userCart.cart_id,
          productCode: userCart.product_code,
          productQuantity: quantity,
        };
        this.updateCartQuantity(cartPayload);
      } else {
        const userItem = JSON.parse(this.$cookies.get("userCart"));
        const newUserItem = userItem.map((item) => {
          if (item.productCode == userCart.productCode)
            item.quantity = quantity;
          return item;
        });
        this.$cookies.set("userCart", JSON.stringify(newUserItem));
        this.fetchLogoutItemDetails();
      }
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
      // console.log(this.scrollPosition);
    },
  },
  created() {
    this.$cookies.set("redirectUrl", window.location.href, null, null, ".avishkaar.cc")
    if (this.$cookies.get("userAccess") !== null) {
      const trackPayload = {
        currentUrl: 'avishkaar.cc'+this.$route.fullPath,
        trackId: 9
      }
      this.fetchUserCart();
      this.fetchUserDetails(trackPayload);
    } else if (this.$cookies.get("userCart") !== null) {
      this.fetchLogoutItemDetails();
    }

  },
  mounted() {
    // window.addEventListener("scroll", function () {
      // this.scrollPosition = window.scrollY;
      // console.log(this.scrollPosition);
      if (window.scrollY == 0) this.scrollPosition = false;
      // "navbar navbar-expand-xl navbar-expand-lg fixed-top navbar-light bg-faded avnav avnav-scrolled"
      else this.scrollPosition = true;
      // "navbar navbar-expand-xl navbar-expand-lg fixed-top navbar-light bg-faded avnav"
      // console.log(this.scrollPosition);
    // });

    window.addEventListener("scroll", this.updateScroll)

		this.currentPage = window.location.pathname;
  },
  destroyed() {
    window.removeEventListener("scroll", this.updateScroll());
  },
};
</script>
<style>
/* code from avishkaar-style.css */
  @import url("https://fonts.googleapis.com/css?family=Roboto:400,400italic,500,500italic,700,700italic,900,900italic,300italic,300,100italic,100");
  @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@600&display=swap");

.login_feature .modal-content::-webkit-scrollbar,
.inner-login-form::-webkit-scrollbar,
.cart_scroll::-webkit-scrollbar
 {
  width: 8px;
  background: transparent;
}
.news-scroll::-webkit-scrollbar {
  width: 1px !important;
  height: 6px;
  background: transparent;
}
.inner-login-form::-webkit-scrollbar-thumb,
.cart_scroll::-webkit-scrollbar-thumb,
.news-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(78, 74, 74, 0.2);
}
.inner-login-form {
  height: 50vh;
  overflow: scroll;
}
.carousel-indicators.new_carousel li {
  background-color: #869791 !important;
  height: 5px;
}
.new_carousel {
  margin-left: 8% !important;
  right: auto !important;
}
.grecaptcha-badge {
  visibility: hidden !important;
}
.navbar {
  top: 0px;
}
.course_alert {
  position: fixed;
  width: 100%;
  background-color: rgb(227, 56, 62);
  z-index: 99;
  color: white;
  border-radius: 0px !important;
  text-align: center;
}
.course_alert a,
.course_alert a:hover {
  color: white;
  text-decoration: underline;
}
.grecaptcha-badge {
  z-index: 1000;
}
.footer-line-height {
  line-height: 1.2;
}
.navbar-custom {
  font-size: 17px;
  color: #ffffff;
}
button:focus {
  outline: none;
}
.img-max {
  max-width: 100%;
}
.hr {
  width: 100%;
  background-color: white;
  display: none;
  margin-top: 9px;
  z-index: 1;
}
.navbar-toggler {
  border-color: #f36f2c !important;
}
.searchimg-toggle {
  display: none;
}

.navbar-custom li {
  display: inline-block;
  list-style: none;
  margin-left: 15px;
  padding-bottom: 18px;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.intl-tel-input {
  display: block !important;
}
#navbarResponsive {
  padding-top: 1.5%;
}
.footer_line {
  border-bottom: 1px solid #686868;
  width: 90%;
  padding-bottom: 5px;
}
::placeholder {
  opacity: 0.5 !important;
}
.form-control1 {
  padding: 0.375rem 1.75rem 0.375rem 0.75rem !important;
}
.btn-color {
  color: #fff;
  background-color: rgb(0, 146, 255);
  border-color: #007bff;
}

.navbar-custom a {
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  border-bottom: none;
}
.sidebar1 .mobile-navbar a {
  color: #6d6f71 !important;
}
.navbar-bootstap {
  padding: 2.1rem 1rem 1.8rem;
}

/*.navbar-custom .nav-pre a:hover{
  border-bottom: 5px solid #007bff;
}
.navbar-default .navbar-toggle
{
  border-color: transparent;
  color: #000000;
}*/
.contents-under {
  padding-top: 75px;
  min-height: 400px;
}
.contents-under-no-header {
  min-height: 400px;
}
.contents-under-sidenav {
  padding-top: 80px;
  min-height: 400px;
  margin-left: 200px;
}
.fa.fa-navicon {
  color: #124d8c;
}
/* .chec-signin { */
  /* position: relative;
  right: -30px; */
/* } */
.navfont {
  font-size: 15px;
  margin-top: 24px;
}
.custom-heading {
  color: #124d8c;
  font-family: Oswald;
  font-size: 14px;
}
.header-img-height {
  width: 160px;
}
.navigation-list {
  width: 70% !important;
}
.mobile-navbar3 {
  font-family: "Roboto";
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 1.25px;
  line-height: 16px;
  text-align: center;
  align-items: center;
  justify-content: center;
  color: #606060 !important;

  box-sizing: border-box;
  height: 38px;
  width: 100px;
  border: 2px solid #505050;
  border-radius: 18px;
}
.user-name {
  color: #606060;
  font-family: "Roboto";
  font-size: 12px;
  letter-spacing: 1.25px;
  line-height: 16px;
  text-align: right;
}
.addressbar-footer {
  background-color: #707070;
  width: 100%;
}
.footer-custom {
  background-color: #3f3e40;
}
.footer-custom a {
  color: #fff;
  text-decoration: none;
  font-size: 13px;
  font-family: "Roboto";
  font-weight: 350;
}
.footer-bo {
  color: #fff;
  text-decoration: none;
  font-size: 13px;
  font-family: "Roboto";
}
.footer-heading {
  color: #fff;
  font-size: 15px;
}
/* .footer-border { */
  /*border: 3px solid #d5d5d5;*/
/* } */
#mc_embed_signup div#mce-responses {
  width: 100% !important;
}
#mc_embed_signup div.response {
  font-size: 15px !important;
}
.footer-custom a:hover {
  color: #fff;
}
.footer-custom a:hover {
  background-color: transparent !important;
}
.header-check-but {
  background-color: #2881c3 !important;
  font-weight: 400 !important;
}
.header-check-but:hover {
  background-color: #2881c3 !important;
}
.header-user-logo {
  height: 38px;
  width: 38px;
  background-color: black;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid gray;
}
.shop-cart {
  border-radius: 20%;
}
input.header-quantity {
  text-align: center;
  border: 1px solid #aaaaaa;
  margin: 0px;
  width: 37px;
  height: 35px;
  background: #f3f3f3;
}
.shop-quantity .decrease {
  margin-right: -4px;
  border-radius: 8px 0 0 8px;
}

.shop-quantity .increase {
  margin-left: -4px;
  border-radius: 0 8px 8px 0;
}
.value-button {
  display: inline-block;
  margin: 0px;
  width: 40px;
  height: auto;
  text-align: center;
  vertical-align: middle;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-top: 5px;
  color: #aaaaaa;
}

.value-button:hover {
  cursor: pointer;
}
.shop-cart span {
  position: absolute;
  background: #4b92e6;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  z-index: 1;
  margin-top: -4px;
  margin-left: -3px;
}
.checkout-signin {
  position: relative;
  right: -30px;
}
.tooltip-container:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
  transition: 0.25s all ease;
  transition-delay: 0s;
}
.tooltip-container:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
  transition: 0.25s all ease;
  transition-delay: 0s;
}
.tooltip-content {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  background: #fff;
  /* left: -38px; */
  top: 45px;
  padding: 0 15px;
  margin: 16px;
  font-size: 15px;
  width: 200px;
  transition: 0.25s all ease;
  transition-delay: 0.25s;
  z-index: 2;
  color: black;
  border-radius: 20px;
  right: 180px;
  box-shadow: 0px 2px 6px #ccc;
}
.tooltip-content-p {
  padding: 10px;
  border-bottom: 1px solid #707070;
  font-weight: 400;
  padding-left: 0px;
}
.logout-tooltip {
  border-bottom: 0px solid transparent !important;
}
.tooltip-content .align-right {
  text-align: right;
}
.tooltip-content .align-right a {
  color: red;
  text-decoration: none;
}
.tooltip-content .align-right a:hover {
  text-decoration: underline;
}
.tooltip-content:after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 17%;
  margin-left: -5px;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
}

.tooltip-content-cart-active {
  visibility: visible !important;
  opacity: 1 !important;
  transition: 0.25s all ease !important;
  transition-delay: 0s !important;
}
.tooltip-content-cart {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  background: rgb(0, 0, 0, 0.5);
  top: 0px;
  font-size: 15px;
  transition: 0.25s all ease;
  transition-delay: 0.25s;
  z-index: 2;
  color: black;
  border: 1px solid #707070;
  right: 0px;
  height: 100vh;
  width: 100%;
  cursor: default;
}
.tooltip-content-cart .inner-shop {
  width: 30%;
  height: 100%;
  margin-left: auto;
  background: #fff !important;
}
.tooltip-content-cart .align-right {
  text-align: right;
}
.tooltip-content-cart .align-right a {
  color: red;
  text-decoration: none;
}
.tooltip-content-cart .align-right a:hover {
  text-decoration: underline;
}
/* .tooltip-content-cart:after { */
  /* content: "";
  position: absolute;
  bottom: 99%;
  left: 91%;
  margin-left: -5px;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent #fff transparent; */
/* } */
/* .tooltip-items-cart {
  background: #eeeeee;
} */
.newsletter {
  color: #575754;
  text-decoration: none;
  font-size: 13px;
  font-family: "Open Sans";
}
.marginr {
  position: relative;
  right: 190px !important;
  top: -47px;
}
.search-container-2 {
  width: 300px;
  vertical-align: middle;
  white-space: nowrap;
  position: relative;
  /* right: -35px; */
}
.image-cart-close {
  position: relative;
  right: 8px;
  top: 7px;
  width: 3%;
  cursor: pointer;
  z-index: 99;
}
.search-container-2 input#search {
  width: 50px;
  height: 50px;
  background: #fff;
  border: none;
  font-size: 10pt;
  float: right;
  color: #262626;
  padding-left: 20px;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  color: gray;
  margin-top: -5px;
  -webkit-transition: width 0.55s ease;
  -moz-transition: width 0.55s ease;
  -ms-transition: width 0.55s ease;
  -o-transition: width 0.55s ease;
  transition: width 0.55s ease;
  color: transparent;
}
.logout a {
  position: absolute;
  right: 80px;
  top: 61px;
}
.search-container-2 .search-icon {
  position: absolute;
  top: 40%;
  left: 257px;
  margin-top: 48px;
  z-index: 1;
  cursor: pointer;
}
.search-container-2 input#search:focus,
.search-container-2 input#search:active {
  outline: none;
  width: 250px;
  background: #fff;
}
.search-container-2:hover input#search {
  width: 240px;
  background: #87898b;
  color: white;
}
.search-container-2:hover .search-icon {
  color: rgb(255, 102, 0);
}
.search-container-2:hover .search-toggler {
  display: none;
}
.search-container-2:hover .searchimg-toggle {
  display: flex;
}
.search-toggler {
  height: 35px;
  position: relative;
  left: 3px;
}
.searchimg-toggle {
  height: 35px;
  position: relative;
  left: 3px;
}
.sidebar1 {
  vertical-align: middle;
  width: 385px;
  height: 30px;
}
.sidebar2 {
  vertical-align: middle;
  width: 385px;
}

/*Facebook*/
a#icon_fb {
  background: rgba(0, 0, 0, 0)
  url('https://www.avishkaar.cc/sites/all/themes/element/images/facebook.png')
  no-repeat scroll 0 0;
  /* display: inline-block; */
  float: left;
  height: 24px;
  text-indent: -9999px;
  width: 24px;
  opacity: 0.5;
}
a#icon_fb:hover {
  background: rgba(0, 0, 0, 0)
    url("https://www.avishkaar.cc/sites/all/themes/element/images/facebook.png")
    no-repeat scroll 0 -24px;
  opacity: 1;
}
/*Googleplus*/
a#icon_gplus {
  background: rgba(0, 0, 0, 0)
  url('https://www.avishkaar.cc/sites/all/themes/element/images/googlep.png')
  no-repeat scroll 0 0;
  /* display: inline-block; */
  float: left;
  height: 24px;
  text-indent: -9999px;
  width: 24px;
  margin-left: 7px;
  opacity: 0.5;
}
a#icon_gplus:hover {
  background: rgba(0, 0, 0, 0)
  url("https://www.avishkaar.cc/sites/all/themes/element/images/googlep.png")
  no-repeat scroll 0 -24px;
  opacity: 1;
}
/*Twitter*/
a#icon_twitt {
  background: rgba(0, 0, 0, 0)
    url('https://www.avishkaar.cc/sites/all/themes/element/images/twitter.png')
    no-repeat scroll 0 0;
  /* display: inline-block; */
  float: left;
  height: 24px;
  text-indent: -9999px;
  width: 24px;
  margin-left: 7px;
  opacity: 0.5;
}
a#icon_twitt:hover {
  background: rgba(0, 0, 0, 0)
    url("https://www.avishkaar.cc/sites/all/themes/element/images/twitter.png")
    no-repeat scroll 0 -24px;
  opacity: 1;
}
/*Youtube*/
a#icon_youtube {
  background: rgba(0, 0, 0, 0)
    url('https://www.avishkaar.cc/sites/all/themes/element/images/ytube.png')
    no-repeat scroll 0 0;
  /* display: inline-block; */
  float: left;
  height: 24px;
  text-indent: -9999px;
  width: 24px;
  margin-left: 7px;
  opacity: 0.5;
}
a#icon_youtube:hover {
  background: rgba(0, 0, 0, 0)
  url("https://www.avishkaar.cc/sites/all/themes/element/images/ytube.png")
  no-repeat scroll 0 -24px;
  opacity: 1;
}
/*Linkedin*/
a#icon_link {
  background: rgba(0, 0, 0, 0)
    url(https://www.avishkaar.cc/sites/all/themes/element/images/linkedin.png)
    no-repeat scroll 0 0;
  /* display: inline-block; */
  float: left;
  height: 24px;
  text-indent: -9999px;
  width: 24px;
  margin-left: 7px;
  opacity: 0.5;
}
a#icon_link:hover {
  background: rgba(0, 0, 0, 0)
    url("https://www.avishkaar.cc/sites/all/themes/element/images/linkedin.png")
    no-repeat scroll 0 -24px;
  opacity: 1;
}
.avnav {
  border-bottom: 1px solid #ccc;
  background: #fff;
  height: 70px;
  box-shadow: 0px 6px 6px #00000029;
}
.navbar .logo {
  width: 100%;
  max-width: 140px;
}
.navbar .tweak_logo {
  width: 100%;
  max-width: 160px;
}
.custom-font-size {
  font-family: "Roboto";
}
/* .row {
  margin-left: 0px;
  margin-right: 0px;
} */
.feature_menu ul {
  text-align: center;
}
.feature_menu ul li {
  display: inline-block;
  margin: 0 20px;

  zoom: 1;
}
.admin_heading {
  font-size: 15px;
  text-align: center;
}
.admin_heading .icon {
  font-size: 58px;
  color: #f07335;
}
.clear {
  clear: both;
}
.loader {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  display: none !important;
  background: url("https://images.avishkaar.cc/workflow/hp_v1/loader_new.gif")
    50% 50% no-repeat rgb(249, 249, 249);
}
/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
}
/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: block;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  right: 0px;
  top: 32px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}
/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}
/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}
.heading_h1,
h1 {
  font-size: 40px;
}
.heading_h2,
h2 {
  font-size: 32px;
}
.heading_h3,
h3 {
  font-size: 28px;
  /*color: #f27322;*/
}
.custom_color_heading {
  color: #f27322;
}
.p,
p {
  letter-spacing: 0.2px;
  color: #515151;
  font-size: 15px;
  /*line-height: 25px;*/
  /*margin-top: 25px;*/
}
.custom-primary-button {
  background: #2199f0;
  font-size: 20px;
  font-family: roboto;
  color: #ffffff;
  font-weight: lighter;
  letter-spacing: 0.2px;
  border-radius: 6px;
}
.custom-primary-button:hover {
  background-color: #0e7ac9;
  color: white;
}
a {
  color: #2199f0;
}
a:hover {
  text-decoration: none;
  color: #0e7ac9;
}
.custom-subheading {
  color: #515151;
  text-transform: none;
  line-height: 25px;
}
.custom-disable {
  font-size: 20px;
  font-family: roboto;
  color: #ffffff;
  font-weight: lighter;
  letter-spacing: 0.2px;
  width: 30%;
  border-radius: 6px;
}
.custom-primary-button-card {
  background: #2199f0;
  font-size: 20px;
  font-family: "Roboto", arial;
  color: #ffffff;
  font-weight: lighter;
  letter-spacing: 0.2px;
  width: 100%;
  border-radius: 6px;
}
.custom-secondary-font {
  font-family: "Archivo Black", sans-serif;
  text-transform: none;
  letter-spacing: 0px;
}
.under {
  position: relative;
  top: -160px;
}
#main12 {
  background-color: #f36f2d;
}
.form-rounded {
  border-radius: 2rem;
}
.recent-heading {
  color: #545454;
  font-family: "Roboto", arial;
  font-size: 18px;
}
.buttonwrapper {
  display: inline-block;
}
.success-msg {
  color: #9fc24c;
}
.failure-msg {
  color: #e2574c;
}
.btn.custom-radius {
  border-radius: 2rem;
}
.underbutton {
  background-color: transparent;
  border: 0;
}
.underbutton {
  position: absolute;
  top: 9px;
  right: 15px;
}
.button1 {
  border-radius: 12px;
}
/*--- avishkaar-learning-program  ---*/
.learning-card {
  min-height: 320px;
}
.video_img {
  width: 100%;
  height: 250px;
}
/*--- tinkering-lab--*/
#tinker {
  background: #e8b75d;
}
#tinker-form {
  background: #050403;
}
.viewmorechallenge {
  background: #124e84;
  color: #fff;
}
.learning-button {
  background-color: #f27321;
  color: #fff;
}
/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
}
/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  right: 0px;
  top: 32px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
/* For form validation message */
.error-message {
  color: red;
  display: none;
  font-weight: normal;
  font-size: 14px;
}
.custom-panel {
  border: none;
  border-radius: 8px;
  text-transform: uppercase;
  text-align: justify;
  font-weight: bold;
  font-size: 24px;
}
.required-text {
  color: red;
  font-weight: normal;
}
/*.navbar-custom a:hover{
  border-bottom: 5px solid brown;
}*/
/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}
.sidenav {
  width: 200px;
  position: fixed;
  z-index: 1;
  top: 80px;
  left: 10px;
  background: #dfdfdf;
  overflow-x: hidden;
  padding: 8px 0;
}
.sidenav a {
  padding: 6px 8px 6px 16px;
  text-decoration: none;
  color: #272727;
  font-size: 13px;
  display: block;
  font-family: "Roboto";
}
.sidenav a:hover {
  color: #064579;
}
.mobile-navbar {
  font-size: 14px;
  float: left;
  margin-left: 180px;
  color: #6d6f71 !important;
}
/*Update: 28/12/18*/
.mobile-navbar-2 {
  padding-right: 4px;
  margin-left: -96px;
  background: #d5d5d5;
  padding-top: 0px;
  border: 1px solid #d5d5d5;
}
.mobile-navbar-3 {
  padding-right: 4px;
  background: #d5d5d5;
  padding-top: 0px;
  border: 1px solid #d5d5d5;
}
.carousel-control-prev-icon,
.carousel-control-next-icon {
  height: 50px;
  width: 50px;
  outline: black;
  background-size: 100%, 100%;
}
.carousel-control-next,
.carousel-control-prev {
  width: 10%;
}
@media only screen and (max-width: 980px) {
  .navbar-custom {
    font-size: 18px;
    color: #ffffff;
    background-image: initial;
    background-image: initial;
    padding-left: 0px !important;
    margin-top: -2px;
    margin-left: -17px;
    margin-right: -17px;
  }
  .search-toggler {
    display: none;
  }
  .form-control1 {
    padding: 0.375rem 0.5rem !important;
  }
  .footer-line-height {
    line-height: 38px;
  }
  .sidebar2 {
    vertical-align: middle;
    width: 385px;
    padding-bottom: 80px;
    margin-bottom: 50px;
  }
  .chec-signin {
    position: relative;
    right: -150px;
    top: -2px;
  }
  .hr {
    display: flex;
    margin-bottom: 0px;
    position: relative;
    top: 0px;
  }
  .footer_line {
    width: 100%;
  }
  .under {
    position: relative;
    top: -100px;
  }
  /* .navbar-toggler:hover {
    background: rgb(227, 70, 0) !important;
  } */
  .mobile-navbar-2 {
    margin-left: 41px;
    margin-bottom: 2%;
    background: none;
    border: none;
  }
  .navbar-custom a:hover {
    border-bottom: none;
  }
  .search-icon-m {
    margin-top: 35px !important;
  }
  .team-logo {
    width: 60px !important;
    left: 20px !important;
    margin-left: 0% !important;
  }
  .about-logo {
    width: 20px !important;
  }
  .search-icon1 {
    margin-top: -7px !important;
  }

  .tweak-nav {
    padding: 1.1rem 2rem 0.8rem 6rem !important;
    font-weight: 400;
    position: relative !important;
    top: 5px !important;
  }
  .sidebar1 {
    margin-bottom: 20px;
    margin-top: 20px;
    position: relative;
    top: 0px;
    height: auto;
  }
  .header-user-logo {
    top: -22px;
    left: 44px;
  }
  .shop-cart {
    margin-left: auto;
  }
  .tooltiptext {
    display: none;
  }
  .shop-cart span {
    top: auto;
    color: white;
    font-weight: bold;
  }
  .tooltip-container {
    width: auto;
  }
}
@media only screen and (max-width: 1199px) and (min-width: 940px) {
  .navbar-custom {
    background-image: initial;
    background-image: initial;
    padding-left: 0px !important;
    margin-top: 11px;
  }
  /* .shop-cart {
    position: relative;
    left: -40px;
  } */
  .chec-signin {
    position: relative;
    right: -12px;
  }
  .tooltip-content {
    top: 34px;
    right: 60px;
  }
  .navbar .logo {
    margin-right: 100px;
    width: 126%;
    max-width: 172px;
  }
  .sidebar1 {
    vertical-align: middle;
    position: relative;
    right: 40px;
    top: -4px;
  }
  .heading_h1,
  h1 {
    font-size: 36px;
  }

  .heading_h2,
  h2 {
    font-size: 30px;
  }
  .heading_h3,
  h3 {
    font-size: 26px;
  }
}
@media only screen and (max-width: 1301px) and (min-width: 1200px) {
  .sidebar1 {
    width: 322px;
  }
  .navbar-custom {
    font-size: 15px;
  }
}
.iframe {
  width: 80% !important;
  height: 80% !important;
}
/* gallery */
.mainbox {
  position: relative;
  height: 140px;
  width: 150px;
  border: 3px solid #e9e9e9;
  overflow: hidden;
}
.image123 {
  display: block;
  width: 300px;
  height: auto;
  position: relative;
  right: 40px;
  bottom: 10px;
}
.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0;
  transition: 0.5s ease;
  background-color: rgba(0, 0, 0, 0.75);
}
.mainbox:hover .overlay {
  opacity: 0.6;
}
.mainbox:hover .icon123 {
  opacity: 1;
  z-index: 1;
}
.icon123 {
  color: white;
  font-size: 40px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  opacity: 0;
}

.shadow-effect {
  background: #fff;
  padding: 20px;
  border-radius: 25px;
  text-align: center;
  border: 1px solid #a8a4a4;
  /*box-shadow: 0 19px 38px rgba(0,0,0,0.10), 0 15px 12px rgba(0,0,0,0.02);*/
}
#customers-testimonials .shadow-effect p {
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  width: 70%;
  text-align: left;
}

#customers-testimonials .item {
  text-align: center;
  padding: 50px;

  /*opacity: .2;*/
  -webkit-transform: scale3d(0.8, 0.8, 1);
  transform: scale3d(0.8, 0.8, 1);
  transition: all 0.3s ease-in-out;
  width: 700px;
  margin-left: -230px;
}
#customers-testimonials .owl-item.active.center .item {
  opacity: 1;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
#customers-testimonials.owl-carousel .owl-dots .owl-dot.active span,
#customers-testimonials.owl-carousel .owl-dots .owl-dot:hover span {
  background: #f27322;
  -webkit-transform: translate3d(0px, -50%, 0px) scale(0.7);
  transform: translate3d(0px, -50%, 0px) scale(0.7);
}
#customers-testimonials.owl-carousel .owl-dots {
  display: inline-block;
  width: 100%;
  text-align: center;
}
#customers-testimonials.owl-carousel .owl-dots .owl-dot {
  display: inline-block;
}
#customers-testimonials.owl-carousel .owl-dots .owl-dot span {
  background: rgba(184, 181, 181, 0.5);
  display: inline-block;
  height: 7px;
  margin: 0 -5px 10px;
  -webkit-transform: translate3d(0px, -50%, 0px) scale(0.3);
  transform: translate3d(0px, -50%, 0px) scale(0.3);
  -webkit-transform-origin: 50% 50% 0;
  transform-origin: 50% 50% 0;
  transition: all 250ms ease-out 0s;
  width: 60px;
  -webkit-transform: translate3d(0px, -50%, 0px) scale(0.7);
  transform: translate3d(0px, -50%, 0px) scale(0.7);
}

.shadow-effect1 {
  background: #fff;
  padding: 16px;
  border-radius: 25px;
  text-align: center;
  border: 1px solid #ececec;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1), 0 15px 12px rgba(0, 0, 0, 0.02);
  margin-top: 20px;
  margin-left: 10px;
}
#customers-testimonials1 .shadow-effect1 p {
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  width: auto;
  text-align: left;
  padding-left: 15px;
}
.margin-text-top {
  margin-top: -3%;
  text-align: center;
}
#customers-testimonials1 .item1 {
  text-align: center;

  /*opacity: .9;*/
  -webkit-transform: scale3d(0.8, 0.8, 1);
  transform: scale3d(0.8, 0.8, 1);
  transition: all 0.6s ease-in-out;
  width: 880px;
  height: 500px;
  /*margin-left: -590px;*/
  margin-left: -390px;
  padding-right: 100px;
  padding-left: 68px;
}
#customers-testimonials1 .owl-item.active.center .item1 {
  opacity: 1;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}
#customers-testimonials1.owl-carousel .owl-dots .owl-dot.active span,
#customers-testimonials1.owl-carousel .owl-dots .owl-dot:hover span {
  background: #f27322;
  -webkit-transform: translate3d(0px, -50%, 0px) scale(0.7);
  transform: translate3d(0px, -50%, 0px) scale(0.7);
}
#customers-testimonials1.owl-carousel .owl-dots {
  display: inline-block;
  width: 100%;
  text-align: center;
}
#customers-testimonials1.owl-carousel .owl-dots .owl-dot {
  display: inline-block;
  position: relative;
  top: -80px;
}
#customers-testimonials1.owl-carousel .owl-dots .owl-dot span {
  background: rgba(184, 181, 181, 0.5);
  display: inline-block;
  height: 7px;
  margin: 0 -5px 10px;
  -webkit-transform: translate3d(0px, -50%, 0px) scale(0.3);
  transform: translate3d(0px, -50%, 0px) scale(0.3);
  -webkit-transform-origin: 50% 50% 0;
  transform-origin: 50% 50% 0;
  transition: all 250ms ease-out 0s;
  width: 60px;
  -webkit-transform: translate3d(0px, -50%, 0px) scale(0.7);
  transform: translate3d(0px, -50%, 0px) scale(0.7);
}

@media only screen and (max-width: 400px) {
  .mainbox {
    height: 125px;
    width: 135px;
    border: 2px solid #e9e9e9;
  }
  .tweak-nav {
    padding: 1.1rem 2rem 0.8rem 5rem !important;
  }
}
@media only screen and (max-width: 667px) and (min-width: 375px) {
  #customers-testimonials1 .item1,
  #customers-testimonials .item {
    width: 100%;
    height: auto;
    margin-left: 0px;
    padding-left: 0px;
    text-align: center;
  }
}

@media only screen and (max-width: 610px) and (min-width: 530px) {
  #customers-testimonials1 .item1,
  #customers-testimonials .item {
    height: unset;
    width: unset;
    margin-left: 0px;
    padding-right: 0px;
    padding-left: 0px;
  }
}

@media only screen and (max-width: 600px) and (min-width: 200px) {
  #customers-testimonials1 .item1,
  #customers-testimonials .item {
    width: 100% !important;
    height: 100%;
    margin-left: 0px !important;
    padding-right: 0px;
    padding-left: 0px;
  }
  #customers-testimonials1.owl-carousel .owl-dots .owl-dot,
  #customers-testimonials.owl-carousel .owl-dots .owl-dot {
    top: unset;
    margin-top: 2%;
  }
  .heading_h1,
  h1 {
    font-size: 27px;
  }

  .heading_h2,
  h2 {
    font-size: 24px;
  }
  .heading_h3,
  h3 {
    font-size: 22px;
  }
  .chec-signin {
    position: relative;
    right: -35px;
  }
}
span.twitter-typeahead {
  display: block !important;
}

.tt-query {
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
}

.tt-hint {
  display: none !important;
  color: #999999;
}

.tt-dropdown-menu {
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  margin-top: 0px;
  padding: 4px 0;
  width: 100%;
  font-size: 14px;
}

.tt-suggestion {
  font-size: 14px;
  line-height: 14px;
  padding: 3px 20px;
}

.tt-suggestion.tt-is-under-cursor {
  background-color: #0097cf;
  color: #ffffff;
}

.tt-suggestion p {
  margin: 0;
}

@media only screen and (max-width: 380px) {
  .footer-custom a {
    font-size: 10px;
  }
}
@media only screen and (max-width: 370px) {
  .form-control1 {
    padding: 0.375rem 3.2rem !important;
  }
  .btn-size {
    padding-left: 102px;
    padding-right: 101px;
    margin-left: 0px !important;
  }

  .header-user-logo {
    left: 30px;
  }
}
@media only screen and (max-width: 330px) {
  .footer-heading {
    font-size: 14px;
  }
  .mobile-search-view {
    right: 18px;
    position: relative;
  }
  .btn-size {
    padding-left: 85px;
    padding-right: 90px;
  }
  .header-user-logo {
    right: -12px;
  }

  .recaptcha-school {
    margin-left: -4px;
    overflow: hidden;
  }
  .navbar .logo {
    width: 86%;
  }
  nav .navigation-list {
    width: 70% !important;
  }
}

.avishkaar-loader {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: #ffffffcf;
}
.avishkaar-loader img {
  position: relative;
  top: 37%;
}
.gsc-selected-option-container {
  max-width: 100% !important;
}

/* avishkaar software */
.main-card {
  max-width: 300px;
  box-shadow: -5px 2px 18px 4px #ccc;
}

.main-card .cover-photo {
  width: 300px;
  height: 100px;
  background: linear-gradient(
    to right,
    rgba(255, 175, 75, 1) 0%,
    rgba(209, 73, 84, 1) 100%
  );
}

.main-card .photo {
  width: 300px;
  height: 100px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.main-card img {
  position: relative;
  top: -50px;
  max-width: 100%;
  max-height: 100%;
}
.main-card .content {
  width: 300px;
  position: relative;
  top: -35px;
  height: 24vh;
}

.main-card .software-footer {
  width: 300px;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: -20%;
}

.main-card a:hover {
  color: black;
}

.main-card ul {
  padding: 0;
}

.main-card:hover {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.software-footer .link-section {
  display: flex;
  box-sizing: border-box;
  width: 60px;
  margin-top: 15%;
  background-color: #2881c3;
  border-radius: 50px;
  overflow: hidden;
  transition: all 0.35s ease-in-out;
}
.software-footer .link-section .links {
  display: flex;
  justify-content: space-around;
  margin: 0px;
  padding: 0px;
}
.software-footer .link-section .links li {
  list-style: none;
}
.software-footer .link-section .links li > a {
  text-decoration: none;
}
.software-footer .link-section .links .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 10px;
  cursor: pointer;
  color: #2881c3;
  font-size: 1.2rem;
  background-color: #ffffff;
  border-radius: 50%;
  transition: all 0.35s ease-in-out;
}
.software-footer .link-section .links .btn:hover {
  font-size: 1.4rem;
  color: #2881c3 !important;
  box-shadow: inset 0px 0px 0px 30px #fff4f8;
}
.software-footer .link-section .links .btn.menu {
  background-color: #2881c3;
  color: #ffffff;
  box-shadow: none !important;
  font-size: 1.4rem;
  cursor: default;
}
.software-footer .link-section:hover,
.software-footer .link-section:focus {
  width: 60%;
}
.software-footer .btn-primary {
  background-color: #2881c3;
}
.software-footer a:hover {
  color: white !important;
}
.soft_card:last-child {
  margin: 0 auto auto auto !important;
  margin-left: 3% !important;
}
@media only screen and (max-width: 1100px) {
  .soft_card:last-child {
    margin-left: 0% !important;
  }
}
@media only screen and (max-width: 1000px) {
  .soft_card:last-child {
    margin: 0 auto auto 20px !important;
  }
}
@media only screen and (max-width: 600px) {
  .soft_card:last-child {
    margin: 0 auto auto auto !important;
  }
}

.cont {
  text-align: center;
}
.page-head .lead {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.4;
  margin-bottom: 50px;
  margin-top: 0;
}
.demo-gallery > ul {
  margin-bottom: 0;
  padding-left: 15px;
}

.demo-gallery > ul > li {
  margin-bottom: 15px;
  width: 180px;
  display: inline-block;
  margin-right: 15px;
  list-style: outside none none;
}

.demo-gallery > ul > li a {
  border: 3px solid #fff;
  border-radius: 3px;
  display: block;
  overflow: hidden;
  position: relative;
  float: left;
}

.demo-gallery > ul > li a > img {
  -webkit-transition: -webkit-transform 0.15s ease 0s;
  -moz-transition: -moz-transform 0.15s ease 0s;
  -o-transition: -o-transform 0.15s ease 0s;
  transition: transform 0.15s ease 0s;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
  height: 100%;
  width: 100%;
}

.demo-gallery > ul > li a:hover > img {
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

.demo-gallery > ul > li a:hover .demo-gallery-poster > img {
  opacity: 1;
}

.demo-gallery > ul > li a .demo-gallery-poster {
  background-color: rgba(0, 0, 0, 0.1);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transition: background-color 0.15s ease 0s;
  -o-transition: background-color 0.15s ease 0s;
  transition: background-color 0.15s ease 0s;
  cursor: pointer;
}

.demo-gallery > ul > li a .demo-gallery-poster > img {
  left: 50%;
  margin-left: -10px;
  margin-top: -10px;
  opacity: 0;
  position: absolute;
  top: 50%;
  -webkit-transition: opacity 0.3s ease 0s;
  -o-transition: opacity 0.3s ease 0s;
  transition: opacity 0.3s ease 0s;
}

.demo-gallery > ul > li a:hover .demo-gallery-poster {
  background-color: rgba(0, 0, 0, 0.5);
}

.demo-gallery .justified-gallery > a > img {
  -webkit-transition: -webkit-transform 0.15s ease 0s;
  -moz-transition: -moz-transform 0.15s ease 0s;
  -o-transition: -o-transform 0.15s ease 0s;
  transition: transform 0.15s ease 0s;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
  height: 100%;
  width: 100%;
}

.demo-gallery .justified-gallery > a:hover > img {
  -webkit-transform: scale3d(1.1, 1.1, 1.1);
  transform: scale3d(1.1, 1.1, 1.1);
}

.demo-gallery .justified-gallery > a:hover .demo-gallery-poster > img {
  opacity: 1;
}

.demo-gallery .justified-gallery > a .demo-gallery-poster {
  background-color: rgba(0, 0, 0, 0.1);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transition: background-color 0.15s ease 0s;
  -o-transition: background-color 0.15s ease 0s;
  transition: background-color 0.15s ease 0s;
}

.demo-gallery .justified-gallery > a .demo-gallery-poster > img {
  left: 50%;
  margin-left: -10px;
  margin-top: -10px;
  opacity: 0;
  position: absolute;
  top: 50%;
  -webkit-transition: opacity 0.3s ease 0s;
  -o-transition: opacity 0.3s ease 0s;
  transition: opacity 0.3s ease 0s;
}

.demo-gallery .justified-gallery > a:hover .demo-gallery-poster {
  background-color: rgba(0, 0, 0, 0.5);
}

.demo-gallery .video .demo-gallery-poster img {
  height: 48px;
  margin-left: -24px;
  margin-top: -24px;
  opacity: 0.8;
  width: 48px;
}

.demo-gallery.dark > ul > li a {
  border: 3px solid #04070a;
}

nav .navigation-list {
  height: 50px;
  line-height: 50px;
}
nav .navigation-list li {
  display: inline-block;
  font-size: 16px;
  color: #707070;
}
nav .toggle {
  display: none;
}

.nav-collsaped {
  position: fixed !important;
  background-color: white;
  left: 0 !important;
  transition: 0.5s;
}
.navCollsaped {
  position: fixed !important;
  background-color: white;
  left: 0 !important;
  transition: 0.5s;
}
.bodyOverlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
  display: inline !important;
  transition: 5s;
}
.login-inner {
  background-color: #fff;
}
.overlay-nav {
  display: none;
  z-index: -1;
  position: fixed;
  left: 0;
  top: 50px;
  background-color: rgba(0, 0, 0, 0);
  transition: 5s;
}

.body-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  display: inline !important;
  transition: 5s;
}
.header-user-logo-mobile {
  height: 38px;
  width: 38px;
  background-color: black;
  border-radius: 50%;
  overflow: hidden;
}
@media (max-width: 1000px) {
  .login_feature_body {
    overflow: scroll !important;
  }
  nav .toggle {
    display: inline-block;
    background-color: transparent;
    border: 1px solid transparent;
    outline: none !important;
    font-size: 25px;
    color: black;
    font-family: serif;
    font-weight: bold;
  }
  nav .navigation-list .navbar-bootstap {
    color: #616163 !important;
    font-weight: 380 !important;
    width: 100%;
  }
  .logo {
    position: relative;
    left: 15px;
  }
  nav .toggle:hover,
  nav .toggle:focus {
    color: #d6d6d6;
  }
  nav .toggle > div {
    width: 25px;
    height: 2px;
    background-color: white;
    margin: 6px 0;
    transition: 0.3s;
  }
  nav .navigation-list {
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    left: -160vh;
    width: 70%;
    transition: 600ms cubic-bezier(0.42, 0, 0, 0.99);
    overflow-x: hidden;
  }
  nav .navigation-list li {
    display: block;
  }
  nav .overlay-nav {
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 1;
    transition: 5s;
  }
  nav .navigation-list {
    line-height: 30px;
  }
  .nav-item {
    margin-left: 0 !important;
    padding-left: 10px;
    font-size: 1.1rem !important;
  }

  .navigation-list .header-item:nth-child(6) {
    border-bottom: 1px solid #616163;
  }
  .login-button a,
  .login-button a:hover,
  .login-button a:active {
    font-size: 14px;
    width: 100%;
    color: #616163 !important;
    background-color: #ffffff !important;
    border: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000029;
    font-weight: 400;
  }
}
/* login feature */

.login_feature {
  overflow: hidden !important;
  background: rgb(0, 0, 0, 0.4);
}
.login_feature .modal-header {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 2;
}
.login_feature .modal-header,
.login_feature .modal-footer {
  border: none;
}
.login_feature .header {
  background: #f36f2e 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  opacity: 1;
  padding: 12px;
}
.login_feature .box-inner .button_login {
  color: #373737;
  border: 1px solid #616163;
  border-radius: 5px;
  opacity: 1;
}
.login_feature .modal-dialog {
  display: flex;
  align-items: center;
  max-width: 60%;
  height: 95vh;
}
.login_feature .modal-content {
  height: 90vh;
  border: none;
  overflow: hidden;
}
.login_feature .select_field {
  border: 2px solid #bfbfbf;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
  letter-spacing: 0;
  color: black;
  cursor: pointer;
  opacity: 1;
  height: calc(1.5em + 0.75rem + 8px) !important;
}
.login_feature .modal-body {
  display: flex;
  align-items: center;
  height: 88vh;
}
.login_feature .sign_in,
.email-verify-btn .box a,
.login_feature .verify_button {
  background: #2881c3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  letter-spacing: 0;
  color: #ffffff;
  /* border-color: #2881c3 !important; */
  box-shadow: 0px 3px 6px #00000029;
  border: none !important;
}
.login_feature .back_button {
  border: none;
  background: transparent;
  color: #2881c3 !important;
}
.box .inputBox {
  position: relative;
}

.box .inputBox input {
  font-size: 1rem;
  letter-spacing: 0.062rem;
  border: 1px solid rgba(25, 25, 25, 0.32);
  border-radius: 5px;
  opacity: 1;
  background: transparent;
}

.box .inputBox label {
  position: absolute;
  top: 12px;
  left: 30px;
  padding: 0.625rem 0;
  font-size: 15px;
  pointer-events: none;
  transition: 0.5s;
  letter-spacing: 0;
  color: #bfbfbf;
  opacity: 1;
}
.box .phone_box label {
  left: 55px !important;
}
.box .common_field label {
  left: 45px !important;
}
.welcome_check {
  font-size: 15px;
  color: #707070;
  opacity: 1;
}
.welcome_check input[type="checkbox"] {
  background: red;
}
.box .inputBox input:focus ~ label,
.box .inputBox input:not([value=""]) ~ label {
  top: -0.5rem;
  left: 30px;
  font-size: 0.75rem;
  background-color: white;
  height: 10px;
  padding: 0 8px 20px 8px;
}
.box .last_name_field label {
  left: 20px !important;
}
.box .phone_box input:focus ~ label,
.box .phone_box input:not([value=""]) ~ label {
  left: 15px !important;
}
.box .common_field input:focus ~ label,
.box .common_field input:not([value=""]) ~ label {
  left: 30px !important;
}
.box .inputBox input:focus {
  outline: none;
  border: 1px solid #ff7033;
}
.box .inputBox input:focus ~ label,
.box .phone_box input:focus ~ label {
  color: #ff7033 !important;
}
.box input[type="submit"] {
  border: none;
  outline: none;
  color: #fff;
  background-color: #1a73e8;
  padding: 0.625rem 1.25rem;
  cursor: pointer;
  border-radius: 0.312rem;
  font-size: 1rem;
  float: right;
}
.color_orange {
  letter-spacing: 0;
  opacity: 1;
  color: #f36f2e;
  cursor: pointer;
}
.color_lgrey {
  color: #989898;
}
.login_feature .modal-footer {
  padding: 0 !important;
}
.login_feature .tel_number {
  height: 100%;
}
.login_feature .toggle-password {
  position: absolute;
  right: 1.5em;
  top: 22px;
  margin-top: -0.5em;
  font-size: 12px;
  line-height: 1;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 18px;
}
.form-logout {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #f27322;
}
@media only screen and (max-width: 1100px) {
  .login_feature .modal-dialog {
    max-width: 70%;
    margin-top: 10px !important;
  }
}
@media only screen and (max-width: 770px) {
  .tooltip-content-cart .inner-shop {
    width: 80%;
  }
  .tooltip-content-cart.tooltip-content-cart-active .back_drop {
    width: 20% !important;
  }
  .login_feature .modal-dialog {
    max-width: 80%;
  }
  .login_feature .modal-body {
    height: auto !important;
  }
  .carousel-indicators.new_carousel li {
    height: 15px;
    width: 15px;
    border-radius: 50%;
  }
  .request-call-inner .modal-dialog {
    max-width: 90% !important;
  }
  .login_feature .modal-content {
    height: 96vh !important;
    overflow: scroll !important;
  }
  .login_feature .modal-dialog {
    margin-top: 15px !important;
  }
  .mobile_cart_view {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    align-items: center;
    display: flex;
  }
  .tooltip-content-cart {
    width: 100vw !important; 
  }
}
@media only screen and (max-width: 430px) {
  #leagueModal .modal-header img {
    width: 30% !important;
    top: -25% !important;
  }
  #leagueModal .main_card_btn {
    font-size: 16px !important;
  }
  #leagueModal .modal-header button {
    font-size: 40px !important;
  }
  #leagueModal .modal-body h2 {
    font-size: 22px !important;
  }
  .tooltip-content-cart .inner-shop {
    width: 90%;
  }
  .tooltip-content-cart.tooltip-content-cart-active .back_drop {
    width: 10% !important;
  }
  .inner-login-form {
    height: 60vh !important;
  }
  .login_feature .modal-dialog {
    max-width: 95%;
  }
  .form-logout {
    position: absolute;
    right: 0px;
    top: 10px;
    color: #f27322;
  }
  .login_feature .modal-content {
    height: 95vh;
  }
}
@media only screen and (min-width: 1400px) {
  .login_feature .modal-content {
    height: 85vh;
  }
  .login_feature .modal-dialog {
    max-width: 55%;
  }
}
.inputBox input::-webkit-input-placeholder {
  /* Edge */
  color: white !important;
}

.inputBox input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white !important;
}

.inputBox input::placeholder {
  color: white !important;
}
.resend_button_disabled {
  -webkit-appearance: none !important;
  border: none !important;
  color: gray !important;
  font-weight: 450 !important;
  text-decoration: underline !important;
  cursor: default !important;
  background: transparent !important;
  box-shadow: none !important;
}
.resend_button_active {
  -webkit-appearance: none !important;
  border: none !important;
  color: #2881c3 !important;
  font-weight: 450 !important;
  text-decoration: underline !important;
  cursor: pointer !important;
  background: transparent !important;
  box-shadow: none !important;
}
.email_svg {
  float: left;
  margin-left: 10px;
  margin-top: -35px;
  position: relative;
  z-index: 2;
}
.sign_in_form .intl-tel-input.allow-dropdown input,
.sign_in_form .intl-tel-input.allow-dropdown input[type="text"],
.sign_in_form .intl-tel-input.allow-dropdown input[type="tel"],
.sign_in_form .intl-tel-input.separate-dial-code input,
.sign_in_form .intl-tel-input.separate-dial-code input[type="text"],
.sign_in_form #sign_email,
.sign_in_form .intl-tel-input.separate-dial-code input[type="tel"] {
  padding-left: 45px !important;
}
.main_bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position-y: 80%;
  background-position-x: center;
}
.email_alert {
  position: fixed;
  z-index: 100;
  width: 100%;
  border-radius: 0;
  background: #2881c3;
  border: none;
  color: white;
  text-align: center;
  font-weight: 300;
  margin-top: 3px;
  display: flex;
}
.email_alert button {
  border: none;
  background: transparent;
  text-decoration: underline;
  color: white;
  font-weight: 300;
  cursor: pointer;
}
.search-icon-m {
  left: 210px !important;
}
.s-icon-out {
  top: 6px !important;
}

.request-header {
  padding: 0 !important;
  background-color: transparent !important;
  border: none !important;
}
.request-call-inner .close-btn {
  width: 38px;
  height: 38px;
  background: #fafafa 0% 0% no-repeat padding-box;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.request-footer {
  background-color: #2881c3;
  padding: 0.4rem;
}
.request-header img {
  cursor: pointer;
}
.color-orange {
  color: #f36f2e;
}
.request-input {
  height: 100%;
}
.shop-product-button {
  background-color: #2881c3;
  font-size: 20px;
  font-weight: 400 !important;
}
.shop-product-button:hover {
  background-color: #2881c3;
}
.request-call h2 {
  font-family: "Poppins", sans-serif;
  font-weight: bold !important;
}
.request-call {
  font-family: "Roboto";
  font-weight: 500;
}
.request-call form input {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border: none !important;
}
.request-call form #submit_phone,
.ok_btn,
.sign_in_inner .login_button {
  background: #ff7033 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 32px;
  border: none !important;
  font-weight: bold;
}
.request-call-inner .modal-dialog {
  max-width: 70%;
  margin-left: auto;
  margin-right: auto;
}

.request_call,
.future_skills {
  background-color: #505050;
  font-family: roboto;
}
.request_call p {
  font-size: 25px;
}
.request_call .btn:focus {
  outline: 0;
  box-shadow: none;
}
.request_call button,
.hp_header button,
.login_next_btn,
.purchase_success_btn {
  background-color: #ff7033;
  box-shadow: 0px 6px 6px #00000029;
  border-radius: 32px !important;
  align-items: center;
}
.request_call button p {
  font-size: 22px;
  font-family: "Roboto";
  font-weight: 300;
}
.request_call button img {
  width: 30px;
  height: 30px;
}
.request-call-inner .modal-dialog {
  height: 100%;
  align-items: center;
  display: flex;
  margin-top: -0;
}
.sign_in_inner input {
  background: #f5f5f5 0% 0% no-repeat padding-box;
  border: none;
}
.sign_in_inner .create_act {
  text-align: center;
  cursor: pointer;
  letter-spacing: -0.08px;
  color: #2680eb;
}
.sign_in_inner h2 {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.sign_in_inner .sec-one {
  background: #fff;
}

.custom-dropdown select {
  display: none;
}
.option[data-display-text]:first-child {
  display: none !important;
}
.custom-dropdown .dropdown {
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#40FFFFFF', endColorstr='#00FFFFFF', GradientType=0);
  font-size: 1rem;
  letter-spacing: 0.062rem;
  border: 1px solid rgba(25, 25, 25, 0.32);
  border-radius: 5px;
  opacity: 1;
  background: transparent;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  float: left;
  font-size: 14px;
  font-weight: normal;
  height: 42px;
  line-height: 40px;
  outline: none;
  padding-left: 18px;
  padding-right: 30px;
  position: relative;
  text-align: left !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  width: 100%;
}
.custom-dropdown .dropdown:focus {
  background-color: #f1f1f1;
}
.custom-dropdown .dropdown:hover {
  background-color: #f3f3f3;
}
.custom-dropdown .dropdown:active,
.custom-dropdown .dropdown.open {
  background-color: #f0f0f0 !important;
  border-color: #e4e4e4;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05) inset;
}
.custom-dropdown .dropdown:after {
  height: 0;
  width: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #777;
  -webkit-transform: origin(50% 20%);
  transform: origin(50% 20%);
  -webkit-transition: all 0.125s ease-in-out;
  transition: all 0.125s ease-in-out;
  content: "";
  display: block;
  margin-top: -2px;
  pointer-events: none;
  position: absolute;
  right: 10px;
  top: 50%;
}
.custom-dropdown .dropdown.open:after {
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}
.custom-dropdown .dropdown.open .list {
  -webkit-transform: scale(1);
  transform: scale(1);
  opacity: 1;
  pointer-events: auto;
  width: 100%;
}
.custom-dropdown .dropdown.open .option {
  cursor: pointer;
}
.custom-dropdown .dropdown.wide {
  width: 100%;
}
.custom-dropdown .dropdown.wide .list {
  left: 0 !important;
  right: 0 !important;
}
.custom-dropdown .dropdown .list {
  box-sizing: border-box;
  -webkit-transition: all 0.15s cubic-bezier(0.25, 0, 0.25, 1.75),
    opacity 0.1s linear;
  transition: all 0.15s cubic-bezier(0.25, 0, 0.25, 1.75), opacity 0.1s linear;
  -webkit-transform: scale(0.75);
  transform: scale(0.75);
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.09);
  background-color: #fff;
  border-radius: 6px;
  margin-top: 4px;
  padding: 3px 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 999;
}
.custom-dropdown .dropdown .list:hover .option:not(:hover) {
  background-color: transparent !important;
}
.custom-dropdown .dropdown .option {
  cursor: default;
  font-weight: 400;
  line-height: 40px;
  outline: none;
  padding-left: 18px;
  padding-right: 29px;
  text-align: left;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.custom-dropdown .dropdown .option:hover,
.custom-dropdown .dropdown .option:focus {
  background-color: #f6f6f6 !important;
}
.custom-dropdown .dropdown .option.selected {
  font-weight: 600;
}
.custom-dropdown .dropdown .option.selected:focus {
  background: #f6f6f6;
}

.by {
  bottom: 12px;
  color: #aaa;
  font-size: 12px;
  left: 0;
  position: absolute;
  right: 0;
  text-align: center;
}

.custom-dropdown a {
  color: #aaa;
  text-decoration: none;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
}
.custom-dropdown a:hover {
  color: #666;
}
.user_check_mark {
  position: absolute;
  top: 12px;
  right: 10px;
}
.quantity {
  width: 10%;
  border: none !important;
}
.inc_dec_btn {
  background: white;
  border: none;
  display: flex;
  align-items: center;
}
.success-box {
  background: #FFFFFF;
box-shadow: -8px 8px 25px rgba(0, 0, 0, 0.09);
border-radius: 10px;
}
#leagueModal .main_card_btn {
  color: #F3743D;
  background: #fff 0% 0% no-repeat padding-box;
  border-radius: 11px;
  box-shadow: 3px 4px 2px #E6E6E6;
  font-size: 20px;
  letter-spacing: 1.08px;
  font-family: roboto;
  position: absolute;
  bottom: 20px;
}
#leagueModal .modal-header img {
  position: absolute;
    top: -30%;
}
#leagueModal .modal-header button {
  font-size: 46px;
  padding: 0;
  position: relative;
  right: 20px;
top: 8px;
opacity: 1;
color: white;
}
#leagueModal .modal-body h2 {
  font-family: roboto !important;
  font-size: 30px;
}
.tooltip-content-cart.tooltip-content-cart-active .back_drop {
  width: 70%;
  height: 100%;
}
.slick-track {
  padding-top: 30px !important;
  padding-bottom: 10px !important;
}


/* header tab selected */
@media screen and (min-width: 576px) {
  .header-nav-active > li {
    border-bottom: solid 3px #ff7033;
  }
  
}

@media screen and (max-width: 575px) {
  .header-nav-active {
    background-color: #ffe7db;
  }
  .header-nav-active > li {
    color: #333 !important;
  }
}

/* end of avishkaar-style.css */
</style>
<style scoped>
/* toggle nav style on {navScrolled} */
.avnav {
  box-shadow: 0 0 0 #fff;
  height: 78px;
}
.avnav-scrolled {
  box-shadow: 0 6px 6px #00000029;
  height: 64px;
}
/* ---- */

.nav-link {
  padding: 0 !important;
}

/* styling nav items */

/* logo */
.nav-left-logo-box {
  background: #fff;
}

.nav-element-active {
  border-bottom: solid 3px #ff7033;
  font-weight: bold;
}

.my-left-nav-item-text-hover:hover {
    color: #000;
  }

/* styling nav items (on left) on mobile device */
@media screen and (max-width: 1000px) {
  .my-left-nav-item {
    height: 40px;
    border: none;

    /* align items on center vertically */
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .my-left-nav-item-text {
    margin-left: 20px;
    margin-right: 25px;
    /* font-weight: 900 !important; */
    font-size: 100%;
  }
  .nav-element-active {
    background-color: #ffe7db;
    /*color: #000 !important;*/
  }
  /*.nav-element-active > div {
    color: #000;
  }*/
	
	.mobile-profile-option {
		height: 60px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.mobile-profile-option > span {
		color: #bcbcbc;
		font-size: 1rem;
	}
	.mobile-profile-option > img {
		height: 40px;
		width: 40px;
		border: solid 1px #000;
		border-radius: 1000px;
	}

	.mobile-nav-footer-options {
		height: 40px;
		font-size: 1rem;
	}
}

/* styling nav items on desktop */
@media screen and (min-width: 1000px) {
	.my-left-nav-item {
		margin-left: 40px;
	}
  .my-left-nav-item-text:hover {
    color: #555 !important;
  }
  /* .my-left-nav-item-text {
    color: #303030;
  } */
}

/* Sign-in button */
.nav-left-signin {
  border: solid 2px #333;
  border-radius: 100px;
  margin: auto 1rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7vh;
}
.nav-left-signin-item {
  padding: 0;
  color: #000;
}

/* ---- */

.sideCartView {
  visibility: visible !important;
  opacity: 1 !important;
}
.request_call button,
.hp_header button,
.login_next_btn,
.purchase_success_btn {
  background-color: #ff7033;
  /* box-shadow: 0 6px 6px #00000029; */
  border-radius: 32px !important;
  align-items: center;
}
.cart_scroll {
  height: 65vh;
}

.mobile-nav-item {
  border-left: 5px solid #ffffff;
  padding-left: 11px;
  display: flex;
  align-items: center;
  height: 6.5vh;
}
.mobile-nav-item-active {
  border-left: 5px solid #e65b20;
}
.mobile-nav-img {
  width: 25px;
  display: flex;
  align-items: center;
}
.mobile-nav-text {
  font-size: 0.875rem;
  font-weight: 500;
  font-family: Poppins;
  color: #8d8d8d;
  margin-left: 1rem;
  line-height: 0;
}
.mobile-nav-text-active {
  font-weight: 700;
  color: #e65b20;
}
</style>
